import * as signalR from '@microsoft/signalr';
import { getUrl } from './Conections';

export let connection;

export const connectToSignalR = async (onAnalyzerStatusUpdate): Promise<void> => {
  const url: string = await getUrl();
  return new Promise((resolve, reject) => {
    connection = new signalR.HubConnectionBuilder().withUrl(`${url}/analyzerHub`).withAutomaticReconnect().configureLogging(signalR.LogLevel.Information).build();

    connection
      .start()
      .then(() => {        
        connection
          .invoke('RegisterReactClient', connection.connectionId)
          .then(() => {
            resolve(); // La conexión está lista
          })
          .catch((err) => {            
            reject(err);
          });
      })
      .catch((err) => {        
        reject(err);
      });

      // 📢 Escuchar cuando un analizador se conecta
      connection.on("AnalyzerConnected", (analyzerId) => {        
        onAnalyzerStatusUpdate(analyzerId, "Activo");
    });

    // 📢 Escuchar cuando un analizador se desconecta    
    connection.on("AnalyzerDisconnected", (analyzerId) => {        
        onAnalyzerStatusUpdate(analyzerId, "Desconectado");
    });
  });
};

export const getConnectedAnalyzers = async () => {
  try {
    const response = await connection.invoke('GetConnectedAnalyzers');    
    return response;
  } catch (error) {    
    return [];
  }
};

export const disconnectSignalR = () => {
  if (connection) {
    connection.stop();    
  }
};
